import { render, staticRenderFns } from "./registration_confirmation.vue?vue&type=template&id=203d28dc&scoped=true&"
import script from "./registration_confirmation.vue?vue&type=script&lang=js&"
export * from "./registration_confirmation.vue?vue&type=script&lang=js&"
import style0 from "./registration_confirmation.vue?vue&type=style&index=0&id=203d28dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d28dc",
  null
  
)

component.options.__file = "registration_confirmation.vue"
export default component.exports